import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ItemAttributeEntity } from '../../domain/entities/ItemAttributeEntity'
export class CreateUpdateItemAttributeModel extends ItemAttributeEntity {
  constructor(dataDto: ItemAttributeEntity) {
    super()
    mapEntityProperties<CreateUpdateItemAttributeModel>(this, dataDto, {
      exclude: ['simpleValues', 'itemValues'],
      map: {
        itemValues: dataDto?.itemValues?.map((item) => ({
          itemId: item.id
        })),
        simpleValues: dataDto?.simpleValues?.map((value) => ({
          id: value.id,
          additionalPrice: value.additionalPrice,
          translations: value.translations,
          image: value.image,
          isAvailable: value.isAvailable
        }))
      }
    })
  }
}
